import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';
import AppProvider from './providers/AppProvider';
import App from './App';
import ToastProvider from './providers/ToastProvider';
import 'react-google-places-autocomplete/dist/index.min.css';

/*
  TODO: Remove the   ⃤
*/
ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <ToastProvider>
        <Router>
          <App />
        </Router>
      </ToastProvider>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root') || document.createElement('div'),
);
